module.exports = __webpack_public_path__ + "img/skeleton2.c8d4190f.jpg";